import {Button, Form, Input, message, Modal, Space} from "antd";
import React, {useContext, useState} from "react";
import {useNavigate} from "react-router-dom";
import {AuthContext} from "../../../../context/AuthContext";
import axios from "../../../../api/axios";
import queryApi from "api/queryApi";

const SAVE_URL = '/didox/account/change_password';


const DidoxUsersTab = (props) => {

    //const navigate = useNavigate();
    const [form] = Form.useForm()

    const [confirmLoading, setConfirmLoading] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();

    const handleFormSubmit = () => {

        form
            .validateFields()
            .then(async (values) => {
                delete values.confirmNew;

                try {
                    const data = await queryApi.post(SAVE_URL,JSON.stringify(values)
                    ).then(response => { console.log(response, 'response')} )
                    messageApi.open({
                        type: 'success',
                        content: 'Муввафакият',
                        duration: 2,
                    }).then(()=> handleCancel() );
                    //message.success('Муввафакият', handleCancel);
                } catch (err) {
                    messageApi.open({
                        type: 'error',
                        content: err.response?.data?.message || "Ошибка",
                        duration: 5,
                    });
                }

            })
            .catch((errorInfo) => {
                console.log('errorInfo ...', errorInfo);
            }).then(r => r);
    }

    const handleCancel = () => {
        props.setShowDidox(false);
    };

    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 8 },
    };

    const tailLayout = {
        wrapperCol: {
            offset: 8,
            span: 16,
        },
    };

    return (
        <>
            {contextHolder}
            <Modal
                title="DIDOX фойдаланувчисини қўшиш"
                open={true}
                //onOk={handleOk}
                confirmLoading={confirmLoading}
                onCancel={handleCancel}
                footer={false}
            >
                <Space direction="horizontal" size="middle" style={{ display: "flex", justifyContent:"center", alignItems: "center", height: "100%", width: "100%", position: "relative", overflow: "hidden" }}/>

                <Form {...layout} name="addTextBook" form={form} scrollToFirstError initialValues={{tin: props?.filialInn?.toString()}}  >
                    {/*onFinishFailed={onFinishFailed}*/}

                    <Form.Item name="tin"  label="ИНН" rules={[{required: true, message:'ИНН киритинг!'}]}>
                        <Input readOnly={true}/>
                    </Form.Item>

                    <Form.Item name="password" label="Парол" rules={[{required:true, message: 'Паролни киритинг'}]}>
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item name="confirmNew" label="Паролни тасдиклаш" rules={[{required:true, message: 'Тасдиклаш паролини киритинг'},
                        ({getFieldValue}) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Пароллар бир бирига тенг эмас'))
                            }
                        })]}>
                        <Input.Password/>
                    </Form.Item>

                    <Form.Item {...tailLayout}>
                        <Button type="primary" htmlType="submit" style={{marginRight:'10px'}} onClick={handleFormSubmit}>
                            Кушиш
                        </Button>

                        <Button type="ghost" htmlType="reset" danger>
                            Тозалаш
                        </Button>
                    </Form.Item>

                </Form>

            </Modal>
        </>
    )
}

export default DidoxUsersTab
